import * as React from 'react';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert'
import { loadStripe } from '@stripe/stripe-js';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';


// Api Calls
import PaymentAPI from "../../../api/api_calls/PaymentAPI";




// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const developmentKey = "pk_test_51OW1YbJb7odiU09e0dfXUJ6KrB6NuoW1oF6NjI9rbERmJvdqsPr9pXyJ8xKaEeEkHswX5lNC2IxGaIJaXKIUkmf500rJHrnRyH"
const productionKey = "pk_live_51OW1YbJb7odiU09eQC5eGaEKkuW4man072XosoxkvxTw81mFzeemwyEyNxQYfOfHPYd0jpVEkYZdEmgDTbV2ACQN00DQWUYbLF"
const publicKey = process.env.NODE_ENV && process.env.NODE_ENV === 'production' ? productionKey : developmentKey;
const stripePromise = loadStripe(publicKey);

const StripePayment = () => {
    const { missionId } = useParams()
    const navigate = useNavigate();
    const alert = useAlert();
    const [clientSecret, setClientSecret] = useState('');
    const [loadingSession, setLoadingSession] = useState(true);

    useEffect(() => {
        // Create a Checkout Session as soon as the page loads
        async function getCheckoutSession() {
            const result = await PaymentAPI.createCheckoutSession({ missionId, navigate });

            if (result.success) {
                setClientSecret(result.client_secret);
                setLoadingSession(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getCheckoutSession();
    }, []);


    const options = { clientSecret };

    return (
        <div id="checkout" className="des-stripe-inner-checkout-container">
            {clientSecret && (
                <EmbeddedCheckoutProvider
                    stripe={stripePromise}
                    options={options}
                >
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            )}
        </div>
    )
}

export default StripePayment;